import { createFileRoute } from "@tanstack/react-router";
import { AdminOpsPanel } from "@/components/admin/AdminOpsPanel";
import { OpsSubnav } from "@/components/OpsSubnav";

export const Route = createFileRoute("/admin/ops/audit-log")({
  component: AuditLogPage,
  head: () => ({ meta: [{ title: "Audit log — Structura Market" }] }),
});

function AuditLogPage() {
  return (
    <div>
      <h1 className="px-6 pt-5 pb-2 text-lg font-bold text-foreground">Audit log</h1>
      <div className="p-4 sm:p-6">
        <OpsSubnav hint="Vista global de auditoría (todos los workspaces). Para filtrar por tenant usá Eventos." />
        <AdminOpsPanel />
      </div>
    </div>
  );
}
